module.exports = __webpack_public_path__ + "img/cprs-ls.41da0aec.png";